import { postPurchaseSurvey } from './post-purchase-survey';
import { customerCheckIn } from './customer-check-in';
import { voiceSurvey } from './voice-survey';
import { testimonialHarvester } from './testimonial-harvester';

// Export all gather insights playbooks
export const gatherInsightsPlaybooks = [
  postPurchaseSurvey,
  customerCheckIn,
  voiceSurvey,
  testimonialHarvester,
];

// Export individual playbooks for direct import
export { 
  postPurchaseSurvey,
  customerCheckIn,
  voiceSurvey,
  testimonialHarvester
};